export type FirmwareVersionTuple = [number, number, number]

// Firmware strings look like "SM_V3_038.0.1 Jul  3 2026 08:22:27" — the trailing build
// timestamp has no dot-separated numbers, so the first N.N.N run is unambiguously the
// version. Leading zeros (e.g. "038") are just padding.
export const parseFirmwareVersion = (firmware: string): FirmwareVersionTuple | null => {
  const match = firmware.match(/(\d+)\.(\d+)\.(\d+)/)
  if (!match) return null
  return [Number(match[1]), Number(match[2]), Number(match[3])]
}

const compareFirmwareVersions = (a: FirmwareVersionTuple, b: FirmwareVersionTuple): number => {
  for (let i = 0; i < 3; i++) {
    if (a[i] !== b[i]) return a[i] - b[i]
  }
  return 0
}

// Unparseable or missing firmware fails closed — never enable a feature we can't confirm
// the device actually supports.
export const isFirmwareAtLeast = (
  firmware: string | undefined,
  minimum: FirmwareVersionTuple,
): boolean => {
  const parsed = firmware ? parseFirmwareVersion(firmware) : null
  return !!parsed && compareFirmwareVersions(parsed, minimum) >= 0
}

export const formatFirmwareVersion = (version: FirmwareVersionTuple): string =>
  version.join('.')
